module.exports = __webpack_public_path__ + "img/1587161527.d79bfe96.jpg";